export default function WhyUsHero() {
  return (
    <section className="relative bg-foreground-950 pt-32 md:pt-40 pb-16 md:pb-24">
      <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=Abstract%20dark%20industrial%20petroleum%20refinery%20with%20dramatic%20orange%20flames%20and%20blue%20steel%20structures%2C%20moody%20atmospheric%20lighting%2C%20cinematic%20industrial%20background%2C%20warm%20and%20cool%20tones%20contrast%2C%20abstract%20energy&width=1600&height=900&seq=whyus-hero-bg&orientation=landscape')] bg-cover bg-center opacity-20" />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/80 to-foreground-950" />

      <div className="relative w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/20 text-accent-300 text-xs font-medium mb-6">
            <i className="ri-star-line text-sm w-4 h-4 flex items-center justify-center" />
            ¿Por Qué Elegirnos?
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5">
            La Mejor Opción para{' '}
            <span className="text-accent-400">Importar Demulsificantes</span>
          </h1>
          <p className="text-foreground-300 text-sm md:text-lg max-w-3xl mx-auto mb-8">
            Conectamos la manufactura de Rixin Corp en China con sus operaciones en Venezuela. 
            Producto ya formulado, logística resuelta, validación técnica local garantizada.
          </p>
        </div>
      </div>
    </section>
  );
}